import React, { useState } from "react";
import { ShieldCheck } from "lucide-react";

export const EmailGate = ({ onSubmit, busy }) => {
  const [email, setEmail] = useState("");
  const submit = (e) => { e.preventDefault(); if (email.trim()) onSubmit(email.trim()); };
  return (
    <form onSubmit={submit} data-testid="email-gate" className="rounded-xl bg-[#F2F8F5] border border-[#008057]/20 p-4">
      <div className="flex items-center gap-2 font-bold text-[#03281B]"><ShieldCheck size={18} className="text-[#008057]" /> Confirm it's you</div>
      <p className="text-sm text-slate-600 mt-1">To protect participants' personal details, enter the parent/guardian email used for this registration.</p>
      <div className="flex gap-2 mt-3">
        <input data-testid="email-gate-input" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Guardian email" className="flex-1 rounded-xl border-2 border-[#E2EBF0] px-3 py-2 text-sm focus:border-[#008057] outline-none bg-white" />
        <button data-testid="email-gate-submit" disabled={busy} className="rounded-xl bg-[#008057] text-white px-4 py-2 font-bold text-sm disabled:opacity-60">{busy ? "Checking..." : "View details"}</button>
      </div>
    </form>
  );
};
